import React from 'react'
import { Grid, makeStyles, Typography } from '@material-ui/core'
import { StarFilledIcon } from '../../../assets/icons/StarFilledIcon'
import { StarEmptyIcon } from '../../../assets/icons/StarEmptyIcon'

export const RatingStars = () => {
  const styleClasses = useStyles()

  return (
    <Grid direction="row" item className={styleClasses.grid}>
      <Grid item xs={12}>
        <div className={styleClasses.stars}>
          {Array.from({ length: 4 }, (_, index) => (
            <StarFilledIcon key={`star-filled-icon-${index}`} fill="#1DD699" />
          ))}
          <StarEmptyIcon fill='#1DD699' />
          <Typography style={{ fontWeight: 600, fontSize: '0.875rem', color: '#000000' }}>
             4,5/5
          </Typography>
        </div>
        <Typography className={styleClasses.title}>
          +5,000 inquilini soddisfatti
        </Typography>
      </Grid>
      <Grid item> </Grid>
    </Grid>
  )
}

const useStyles = makeStyles((theme) => ({
  grid: {
    [theme.breakpoints.up('md')]: {
      padding: '2rem 0 0 0'
    }
  },
  stars: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
    }
  },
  title: {
    color: '#000000',
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontWeight: 400,
      fontSize: '0.75rem'
    }
  }
}));